import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { NotificationComponent } from './components/notification.component';
import { DsToastComponent } from '@design-system/ds-toast/component/ds-toast.component';
import { NotificationToastHeaderPipe } from '@modules/notification/pipes/notification-toast-header.pipe';

@NgModule({
  declarations: [NotificationComponent],
  exports: [NotificationComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule, DsToastComponent, NotificationToastHeaderPipe],
})
export class NotificationModule {}
